export default __webpack_public_path__ + "static/media/spaces_in_riyadh_256.ae3e4ab4.jpg";